import { render, staticRenderFns } from "./ChairAmountForm.vue?vue&type=template&id=4323284f&scoped=true&"
import script from "./ChairAmountForm.vue?vue&type=script&lang=js&"
export * from "./ChairAmountForm.vue?vue&type=script&lang=js&"
import style0 from "./ChairAmountForm.vue?vue&type=style&index=0&id=4323284f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4323284f",
  null
  
)

export default component.exports